import styled from 'styled-components'
import theme from '~/styles/theme'
import Box from './box'

export default styled(Box)`
  width: calc(100% + ${theme.flexboxgrid.outerMargin * 2}rem);
  border-bottom: 1px dashed rgba(0,0,0,0.5);
  margin-left: -${theme.flexboxgrid.outerMargin}rem;
`
